// #######AUTH########
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const UPDATE_ROLES = 'update-roles';
export const REFRESH_USER = 'refresh-user';
export const CHANGE_SELECTED_COMPANY = 'change-selected-component';
